(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-silensa-scroll-to-product]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const productInfo = document.querySelector('product-info');
      if (!productInfo) return;
      event.preventDefault();
      productInfo.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
    });
  });

  const bars = document.querySelectorAll('[data-silensa-mobile-order-bar]');

  bars.forEach((bar) => {
    const targetId = bar.dataset.target;
    const target = targetId ? document.getElementById(targetId) : null;
    const button = bar.querySelector('button');
    const priceOutput = bar.querySelector('[data-silensa-mobile-price]');
    const primaryButton = target?.querySelector('.product-form__submit');
    const priceContainer = target?.querySelector('[id^="price-"]');

    if (!target || !button || !primaryButton) return;

    document.body.appendChild(bar);

    let hasSeenPrimary = false;

    const readCurrentPrice = () => {
      const salePrice = priceContainer?.querySelector('.price__sale .price-item--sale');
      const regularPrice = priceContainer?.querySelector('.price__regular .price-item--regular');
      const fallbackPrice = priceContainer?.querySelector('.price-item');
      const onSale = priceContainer?.querySelector('.price--on-sale');
      return ((onSale ? salePrice : regularPrice) || fallbackPrice)?.textContent?.trim() || '';
    };

    const updateState = () => {
      const disabled = primaryButton.disabled || primaryButton.getAttribute('aria-disabled') === 'true';
      const currentPrice = readCurrentPrice();
      if (priceOutput && currentPrice) priceOutput.textContent = currentPrice;
      button.disabled = disabled;
      button.textContent = disabled ? button.dataset.soldOutLabel : button.dataset.addLabel;
    };

    const updateVisibility = () => {
      const primaryButtonBox = primaryButton.getBoundingClientRect();
      const primaryButtonVisible = primaryButtonBox.top < window.innerHeight && primaryButtonBox.bottom > 0;
      const passedPrimaryButton = primaryButtonBox.bottom < 0;
      if (primaryButtonVisible || passedPrimaryButton) hasSeenPrimary = true;
      const consentVisible = [...document.querySelectorAll('#shopify-pc__banner, #shopify-pc__prefs, .shopify-pc__prefs__dialog')].some((element) => element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
      const visible = hasSeenPrimary && !primaryButtonVisible && !consentVisible;
      bar.classList.toggle('is-visible', visible);
      bar.inert = !visible;
      bar.setAttribute('aria-hidden', String(!visible));
    };

    button.addEventListener('click', () => {
      if (button.disabled) {
        const variantPicker = target.querySelector('variant-selects, variant-radios');
        const destination = variantPicker || primaryButton;
        destination.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
        return;
      }

      primaryButton.click();
    });

    target.addEventListener('change', () => window.setTimeout(updateState, 80));

    const stateObserver = new MutationObserver(updateState);
    if (priceContainer) stateObserver.observe(priceContainer, { subtree: true, childList: true, characterData: true });
    stateObserver.observe(primaryButton, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });

    const visibilityObserver = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) hasSeenPrimary = true;
        updateVisibility();
      },
      { threshold: 0.05 }
    );
    visibilityObserver.observe(primaryButton);

    updateState();
    updateVisibility();
    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility);
    const consentTargets = new WeakSet();
    const consentObserver = new MutationObserver(updateVisibility);
    const observeConsent = () => {
      document.querySelectorAll('#shopify-pc__banner, #shopify-pc__prefs, .shopify-pc__prefs__dialog').forEach((element) => {
        if (consentTargets.has(element)) return;
        consentTargets.add(element);
        consentObserver.observe(element, { attributes: true, attributeFilter: ['class', 'style', 'hidden'], childList: true });
      });
      updateVisibility();
    };
    const consentMountObserver = new MutationObserver(observeConsent);
    consentMountObserver.observe(document.body, { childList: true });
    observeConsent();
    document.addEventListener('visitorConsentCollected', updateVisibility);
  });
})();
